import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import {Box, Grid, Heading, Text} from '@tenancy.nz/ui';
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import IconLabel from './IconLabel';

function PropertyAttributes({
  address = undefined,
  availableAt = undefined,
  noOfBedrooms = undefined,
  noOfBathrooms = undefined,
  noOfCarparks = undefined,
  rent = undefined,
  spacing = 4,
  type = undefined,
  iconSize = '21px',
  sx = {},
}) {
  const labelProps = {...(sx.fontSize && {size: sx.fontSize})};
  const iconBoxStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: iconSize,
    height: iconSize,
    fontSize: iconSize,
  };
  return (
    <Stack
      sx={{
        color: 'text.primary',
        gap: {xs: 2, md: 4},
        ...sx,
      }}>
      {address && (
        <Heading as="h6" color="inherit" gutterBottom={false}>
          {address}
        </Heading>
      )}
      {rent && <Text paragraph>{rent}</Text>}
      <Grid container spacing={spacing}>
        {!!type && (
          <Grid item>
            <IconLabel
              color="tertiary"
              icon="home"
              text={type}
              {...labelProps}
            />
          </Grid>
        )}
        {!!noOfBedrooms && (
          <Grid item>
            <IconLabel
              icon={
                <Box sx={iconBoxStyles}>
                  <BedIcon color="tertiary" fontSize="inherit" />
                </Box>
              }
              text={noOfBedrooms}
              {...labelProps}
            />
          </Grid>
        )}
        {!!noOfBathrooms && (
          <Grid item>
            <IconLabel
              color="tertiary"
              icon={
                <Box sx={iconBoxStyles}>
                  <BathtubIcon color="tertiary" fontSize="inherit" />
                </Box>
              }
              {...labelProps}
              text={noOfBathrooms}
            />
          </Grid>
        )}
        {(!!noOfCarparks || noOfCarparks === 0) && (
          <Grid item>
            <IconLabel
              color="tertiary"
              icon={
                <Box sx={iconBoxStyles}>
                  <DirectionsCarIcon color="tertiary" fontSize="inherit" />
                </Box>
              }
              {...labelProps}
              text={noOfCarparks === 0 ? '0' : noOfCarparks}
            />
          </Grid>
        )}
      </Grid>
      {availableAt && (
        <Text>
          <strong>Available: {availableAt}</strong>
        </Text>
      )}
    </Stack>
  );
}

PropertyAttributes.propTypes = {
  address: PropTypes.string,
  availableAt: PropTypes.string,
  noOfBedrooms: PropTypes.number,
  noOfBathrooms: PropTypes.number,
  noOfCarparks: PropTypes.number,
  rent: PropTypes.string,
  spacing: PropTypes.number,
  type: PropTypes.string,
  iconSize: PropTypes.string,
  sx: PropTypes.object,
};

export default PropertyAttributes;
